import axios from 'axios';
import cookie from 'react-cookies';
import { FieldTypes, ImageUrlFields, REST_API, systemDateField } from 'drapcode-constant';
export const methodTypes = [
  { value: 'GET', label: 'GET' },
  { value: 'POST', label: 'POST' },
  { value: 'PUT', label: 'PUT' },
  { value: 'PATCH', label: 'PATCH' },
  { value: 'DELETE', label: 'DELETE' },
];

export const userUtilPaths = [
  { url: '/login', description: `Login with Username and Password` },
  { url: '/signup/send-email-otp', description: `Send OTP to Email for Signup.` },
  { url: '/signup/verify-email-otp', description: `Verify Email OTP for Signup.` },
  { url: '/login/send-email-otp', description: `Send OTP to Email for Login.` },
  { url: '/login/verify-email-otp', description: `Verify Email OTP for Login.` },
  { url: '/signup/send-sms-otp', description: `Send OTP to SMS for Signup.` },
  { url: '/signup/verify-sms-otp', description: `Verify SMS OTP for Signup.` },
  { url: '/login/send-sms-otp', description: `Send OTP to SMS for Login.` },
  { url: '/login/verify-sms-otp', description: `Verify SMS OTP for Login.` },
  { url: '/user/me', description: 'About Me' },
  { url: '/generate-secret-code', description: 'Generate Secret Code', method: 'GET' },
  { url: '/verify-secret-code', description: 'Verify Secret Code' },
  { url: '/authorize-secret-code', description: 'Authorize Secret Code' },
  { url: '/reset-secret-code', description: 'Reset Secret Code' },
];

const { uuid, createdBy, isDeleted } = FieldTypes;

export const getDescriptionForCheckbox = (dependency, isChecked) => {
  let description = '';

  switch (dependency) {
    case 'enable':
      description = isChecked
        ? `API is enabled (available for usage)`
        : `API is disabled (unavailable for usage)`;
      break;
    case 'auth':
      description = isChecked ? `Developer API key is required` : `Developer API will be public`;
      break;
    case 'isEncrypted':
      description = isChecked ? `Data will be encrypted` : `Data will be decrypted`;
      break;
    case 'userAuthenticate':
      description = isChecked
        ? `User authentication is required`
        : `User authentication is not required`;
      break;
    default:
      description = '';
      break;
  }

  return description;
};
export const createUtilityPath = (devApis) => {
  const paths = [];
  // Any File to Text
  let method = 'POST';
  let collPath = `/anyFileToText`;
  let finalUniqueKey = `${method}-${collPath}`;
  let urlDescription = `Extract Text from single File`;
  let path = createUtilPath(devApis, method, collPath, finalUniqueKey, urlDescription);
  paths.push(path);

  // Any File to Text Multi
  collPath = `/multi-file/anyFileToText`;
  finalUniqueKey = `${method}-${collPath}`;
  urlDescription = `Extract Text from multiple Files`;
  path = createUtilPath(devApis, method, collPath, finalUniqueKey, urlDescription);
  paths.push(path);

  return paths;
};

const createUtilPath = (devApis, method, collPath, finalUniqueKey, urlDescription) => {
  const devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  return {
    collectionName: 'Utility',
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method,
    uniqueKey: finalUniqueKey,
    url: collPath,
    urlDescription: urlDescription,
  };
};

export const createAllPath = (collection, emailTemplate, devApis) => {
  const { collectionName, collectionTitle, finders, constructors, fields } = collection;
  const paths = [];
  const uniqueKey = `${collectionName}-`;
  const collPath = `/collection/${collectionName}/`;
  devApis = devApis.filter((api) => api.collectionName === collectionName);

  //Create Item Path
  let method = 'POST';
  let finalUniqueKey = `${uniqueKey}${method}-${collPath}items`;
  let devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);

  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `${collPath}items`,
    urlDescription: `Create item of ${collectionTitle}`,
  });

  //Create Items with Ref
  method = 'POST';
  finalUniqueKey = `${uniqueKey}${method}-${collPath}itemsWithUUID`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);

  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `${collPath}itemsWithUUID`,
    urlDescription: `Create item of ${collectionTitle} with UUID field`,
  });

  //GET Item
  method = 'GET';
  finalUniqueKey = `${uniqueKey}${method}-${collPath}items`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);

  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `${collPath}items`,
    urlDescription: `Get all items of ${collectionTitle}`,
  });
  //Finder Get Item
  method = 'GET_FILTER_ITEMS';
  if (finders && finders.length) {
    finders.forEach((finder) => {
      const finderPath = `filter/${finder.uuid}/items`;
      finalUniqueKey = `${uniqueKey}${method}-${collPath}${finderPath}`;
      devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
      paths.push({
        collectionName,
        auth: devApi ? devApi.auth : false,
        enable: devApi ? devApi.enable : false,
        isEncrypted: devApi ? devApi.isEncrypted : false,
        userAuthenticate: devApi ? devApi.userAuthenticate : false,
        roles: devApi ? devApi.roles : [],
        permissions: devApi ? devApi.permissions : [],
        method: method,
        uniqueKey: finalUniqueKey,
        url: `${collPath}${finderPath}`,
        urlDescription: `Get filtered item (${finder.name}) of ${collectionTitle}`,
      });
    });
  }
  //Get item by ids
  method = 'POST_ITEMS_BY_IDS';
  finalUniqueKey = `${uniqueKey}${method}-${collPath}itemsbyids`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `${collPath}itemsbyids`,
    urlDescription: `Create items by itemsids in ${collectionTitle}`,
  });
  // Get item by id
  method = 'GET_ITEM';
  finalUniqueKey = `${uniqueKey}${method}-${collPath}item/{itemUuid}`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `${collPath}item/{itemUuid}`,
    urlDescription: `Get item by itemUuid in ${collectionTitle}`,
  });
  // Put item by id
  method = 'PUT_ITEM';
  finalUniqueKey = `${uniqueKey}${method}-${collPath}item/{itemUuid}`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `${collPath}item/{itemUuid}`,
    urlDescription: `Update item by itemUuid in ${collectionTitle}`,
  });
  // Delete item by id
  method = 'DELETE_ITEM';
  finalUniqueKey = `${uniqueKey}${method}-${collPath}item/{itemUuid}`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `${collPath}item/{itemUuid}`,
    urlDescription: `Delete item by itemUuid in ${collectionTitle}`,
  });

  method = 'DELETE_ITEM';
  finalUniqueKey = `${uniqueKey}${method}-${collPath}clear-item/`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `${collPath}clear-item`,
    urlDescription: `Delete All item in ${collectionTitle}`,
  });
  // Post bulk
  method = 'POST_BULK_UPLOAD_ITEMS';
  finalUniqueKey = `${uniqueKey}${method}-${collPath}bulk/`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `${collPath}bulk/`,
    urlDescription: `Create bulk items in ${collectionTitle}`,
  });
  // Post bulk delete
  method = 'POST_BULK_DELETE';
  finalUniqueKey = `${uniqueKey}${method}-${collPath}bulkDelete`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `${collPath}bulkDelete`,
    urlDescription: `Delete bulk items from ${collectionTitle}`,
  });

  //Post constructor
  method = 'POST_ITEMS_CONSTRUCTOR';
  if (constructors && constructors.length) {
    constructors.forEach((constructor) => {
      const finderPath = `items/constructor/${constructor.uuid}`;
      finalUniqueKey = `${uniqueKey}${method}-${collPath}${finderPath}`;
      devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
      paths.push({
        collectionName,
        auth: devApi ? devApi.auth : false,
        enable: devApi ? devApi.enable : false,
        isEncrypted: devApi ? devApi.isEncrypted : false,
        userAuthenticate: devApi ? devApi.userAuthenticate : false,
        roles: devApi ? devApi.roles : [],
        permissions: devApi ? devApi.permissions : [],
        method: method,
        uniqueKey: finalUniqueKey,
        url: `${collPath}${finderPath}`,
        urlDescription: `Create item using predefined values (${constructor.customConstructorName}) in ${collectionTitle}`,
      });
    });
  }
  //Upload
  method = 'POST_UPLOAD';
  const fileFields = fields.filter((field) => ImageUrlFields.includes(field.type));
  if (fileFields && fileFields.length) {
    fileFields.forEach((field) => {
      finalUniqueKey = `${uniqueKey}${method}-/upload/${collectionName}/${field.uuid}`;
      devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
      paths.push({
        collectionName,
        auth: devApi ? devApi.auth : false,
        enable: devApi ? devApi.enable : false,
        isEncrypted: devApi ? devApi.isEncrypted : false,
        userAuthenticate: devApi ? devApi.userAuthenticate : false,
        roles: devApi ? devApi.roles : [],
        permissions: devApi ? devApi.permissions : [],
        method: method,
        uniqueKey: finalUniqueKey,
        url: `/upload/${collectionName}/${field.fieldName}`,
        urlDescription: `Upload file in ${field.fieldTitle.en} of ${collectionTitle}`,
      });
    });
  }

  const filEmailTemplates = emailTemplate.filter(
    (template) => template.collectionId === collectionName,
  );
  if (filEmailTemplates && filEmailTemplates.length) {
    filEmailTemplates.forEach((template) => {
      method = 'POST_SEND_EMAIL';
      finalUniqueKey = `${uniqueKey}${method}-/sendEmail/${template.uuid}/user/{sendTo}`;
      devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
      paths.push({
        collectionName,
        auth: devApi ? devApi.auth : false,
        enable: devApi ? devApi.enable : false,
        isEncrypted: devApi ? devApi.isEncrypted : false,
        userAuthenticate: devApi ? devApi.userAuthenticate : false,
        roles: devApi ? devApi.roles : [],
        permissions: devApi ? devApi.permissions : [],
        method: method,
        uniqueKey: finalUniqueKey,
        url: `/sendEmail/${template.uuid}/user/{sendTo}`,
        urlDescription: `Send Email (${template.name}) to send to.`,
      });
      method = 'POST_SEND_DYNAMIC_EMAIL';
      finalUniqueKey = `${uniqueKey}${method}-/sendDynamicEmail/${template.uuid}/sendToCollection/${collectionName}/item/{collectionItemId}`;
      devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
      paths.push({
        collectionName,
        auth: devApi ? devApi.auth : false,
        enable: devApi ? devApi.enable : false,
        isEncrypted: devApi ? devApi.isEncrypted : false,
        userAuthenticate: devApi ? devApi.userAuthenticate : false,
        roles: devApi ? devApi.roles : [],
        permissions: devApi ? devApi.permissions : [],
        method: method,
        uniqueKey: finalUniqueKey,
        url: `/sendDynamicEmail/${template.uuid}/sendToCollection/${collectionName}/item/{collectionItemId}`,
        urlDescription: `Send dynamic content of ${collectionTitle} in mail (${template.name})`,
      });
    });
  }

  if (collectionName === 'user') {
    // Login User
    let method = 'POST';
    userUtilPaths.forEach((path) => {
      let finalUniqueKey = `${uniqueKey}${method}-${path.url}`;
      let devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
      paths.push({
        collectionName,
        auth: devApi ? devApi.auth : false,
        enable: devApi ? devApi.enable : false,
        isEncrypted: devApi ? devApi.isEncrypted : false,
        userAuthenticate: devApi ? devApi.userAuthenticate : false,
        roles: devApi ? devApi.roles : [],
        permissions: devApi ? devApi.permissions : [],
        method: path.method || method,
        uniqueKey: finalUniqueKey,
        url: path.url,
        urlDescription: path.description,
      });
    });
  }
  method = 'PUT_FILE_OBJECT';
  finalUniqueKey = `${uniqueKey}${method}-/updateFileObject/fileObjectUuid`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `/updateFileObject/${collectionName}/{fileObjectUuid}`,
    urlDescription: `Update File Object from ${collectionTitle} (query: ?itemUuid={itemUuid}&fieldName={fieldName})`,
  });

  method = 'GET_TYPESENSE_INDEXED_DATA';
  finalUniqueKey = `${uniqueKey}${method}-/typesense-search/get-all-indexed-data`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `/typesense-search/get-all-indexed-data/${collectionName}/{filterId}`,
    urlDescription: `Get all Typesense indexed data for ${collectionTitle}. `,
  });

  method = 'GET_FILE_BUFFER';
  finalUniqueKey = `${uniqueKey}${method}-/get-file-buffer/fileObjectUuid`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `/get-file-buffer/${collectionName}/{fileObjectUuid}`,
    urlDescription: `Get File Buffer from ${collectionTitle} (query: ?itemUuid={itemUuid}&fieldName={fieldName})`,
  });
  return paths;
};

export const apiTypes = [
  { value: 'DATA_SOURCE_API', label: 'Data Source API' },
  { value: 'DEVELOPER_API', label: 'Developer API' },
  { value: 'EXTERNAL_API', label: 'External API' },
  { value: 'WEBHOOK_API', label: 'Webhook API' },
];

export const encryptionTypes = [
  { value: 'KMS', label: 'AWS KMS Encryption' },
  { value: 'CUSTOM', label: 'Custom Encryption' },
];
export const encryptionAlgorithmTypes = [{ value: 'aes-256-cbc', label: 'AES-256-CBC' }];

export const defaultOption = { id: 1, key: '', value: '' };
export const apiTypeImages = {
  AIRTABLE: 'airtable.svg',
  REST_API: 'rocket.svg',
  DIRECTUS: 'directus.svg',
  DATABASE: 'database.svg',
  INTEGROMAT: 'integromat.svg',
  ZAPIER: 'zapier.svg',
  XANO: 'xano.svg',
  SUPABASE: 'supabase.svg',
  DIRECTUS: 'directus.svg',
  NOTION: 'notion.svg',
  APP_WRITE: 'appwrite.svg',
  XATA: 'xata.svg',
  GOOGLE_SHEET: 'google-sheets.svg',
  FIREBASE_REALTIME_DATABASE: 'firebase-realtime-database.svg',
  FIREBASE_CLOUD_FIRESTORE: 'firebase-cloud-firestore.svg',
  FIREBASE_FUNCTION: 'firebase-cloud-function.svg',
  XATA: 'xata.svg',
  SALESFORCE: 'salesforce.svg',
  MYSQL: 'mysql.svg',
};

export const headerSuggestions = [
  { text: 'Accept' },
  { text: 'Content-Type' },
  { text: 'Authorization' },
  { text: 'Host' },
];

export const valueSuggestions = [
  { text: 'application/json' },
  { text: 'application/xml' },
  { text: 'text/plain' },
  { text: 'application/atom+xml' },
  { text: 'application/octet-stream' },
];

export const getKeySuggestions = (value) => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  return inputLength === 0
    ? []
    : headerSuggestions.filter(
        (lang) => lang.text.toLowerCase().slice(0, inputLength) === inputValue,
      );
};

export const getValueSuggestions = (value) => {
  const inputValue = value.trim().toLowerCase();
  return inputValue.length === 0
    ? []
    : valueSuggestions.filter((lang) => lang.text.toLowerCase().includes(inputValue));
};

export const getSuggestion = (suggestion) => suggestion.text;

const textTypeParams = [
  'startString',
  'endString',
  'separator',
  'expression',
  'numberOfRecords',
  'tableStyle',
  'theadStyle',
  'tbodyStyle',
  'trStyle',
  'tdStyle',
  'thStyle',
];

export const parseUtilityFunctionFormData = (values) => {
  values = filterUtilityData(values);
  const utilityData = { name: '', functionType: '', args: [] };
  Object.keys(values).forEach((key) => {
    if (key === 'functionName') {
      utilityData.name = values.functionName;
    } else if (key === 'methodType') {
      utilityData.functionType = values.methodType.value;
    } else if (key && values[key]) {
      if (values[key] instanceof Array) {
        if (values[key].length === 1) {
          utilityData.args.push({ name: key, key: values[key][0].value });
        } else {
          const fields = [];
          values[key].forEach((key) => fields.push(key.value));
          utilityData.args.push({ name: key, key: fields });
        }
      } else if (
        [
          'whitespace',
          'noSplitopt',
          'length',
          'endopt',
          'startLength',
          'endLength',
          'indexNum',
          'unitToAdd',
        ].includes(key)
      ) {
        utilityData.args.push({ name: key, key: values[key] });
      } else if (textTypeParams.includes(key)) {
        const value = values[key] && values[key].value ? values[key].value : values[key];
        const replacedValue = stringToExpression(value);
        utilityData.args.push({ name: key, key: replacedValue });
      } else if (key === 'currency') {
        let value = '';
        if (values.currency.value.code === 'NONE') {
          value = 'NONE';
        } else if (!values.displayType || !values.displayType.value) {
          value = values.currency.value['code'];
        } else value = values.currency.value[values.displayType.value];
        utilityData.args.push({ name: key, key: value });
      } else {
        utilityData.args.push({ name: key, key: values[key].value });
      }
    }
  });
  return utilityData;
};

const filterUtilityData = (utilityData) => {
  switch (utilityData.methodType.value) {
    case 'AVERAGE':
    case 'MULTIPLY':
    case 'ADDITION':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        formatType: utilityData.formatType,
        numbers: utilityData.numbers,
      };
      break;
    case 'DIVIDE':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        formatType: utilityData.formatType,
        numbers1: utilityData.number1,
        numbers2: utilityData.number2,
      };
      break;
    case 'CUSTOM_CALCULATION':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        expression: utilityData.expression,
        formatType: utilityData.formatType,
      };
      break;
    case 'CUSTOM_JAVASCRIPT_LOGIC':
    case 'CUSTOM_SENTENCE':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        expression: utilityData.expression,
      };
      break;
    case 'SUBSTRACTION':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        formatType: utilityData.formatType,
        numbers1: utilityData.numbers1,
        numbers2: utilityData.numbers2,
      };
      break;
    case 'CAPITALIZE':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        restToLower: utilityData.restToLower,
        subject: utilityData.subject,
      };
      break;
    case 'LOWER_CASE':
    case 'UPPER_CASE':
    case 'SLUGIFY':
    case 'COUNT':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        condition: utilityData.condition,
        refField: utilityData.refField,
        refFieldType: utilityData.refFieldType,
        match: utilityData.match,
      };
      break;
    case 'PERCENTAGE':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        condition: utilityData.condition,
        refField: utilityData.refField,
        refFieldType: utilityData.refFieldType,
        match: utilityData.match,
        formatType: utilityData.formatType,
      };
    case 'FIND_RECORD':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        refField: utilityData.refField,
        record: utilityData.record,
        index: utilityData.index,
      };
      break;
    case 'TRIM':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        whitespace: utilityData.whitespace,
        type: utilityData.type,
      };
      break;
    case 'TITLE_CASE':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        noSplitopt: utilityData.noSplitopt,
      };
      break;
    case 'TRUNCATE':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        length: utilityData.length,
        endopt: utilityData.endopt,
      };
      break;
    case 'SUB_STRING':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        startLength: utilityData.startLength,
        endLength: utilityData.endLength,
      };
      break;
    case 'STRING_JOIN':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        textFields: utilityData.textFields,
        startString: utilityData.startString,
        endString: utilityData.endString,
        separator: utilityData.separator,
      };
      break;
    case 'SPLIT_STRING':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        separator: utilityData.separator,
        index: utilityData.index,
        indexNum: utilityData.indexNum,
      };
      break;
    case 'FORMAT_DATE':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        formatType: utilityData.formatType,
        datentime: utilityData.datentime,
        unixType: utilityData.unixType ? utilityData.unixType : '',
      };
      break;
    case 'CURRENCY_FORMAT':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        formatType: utilityData.formatType,
        subject: utilityData.subject,
        currency: utilityData.currency,
        position: utilityData.position,
        displayType: utilityData.displayType,
        maxFraction: utilityData.maxFraction,
      };
      break;
    case 'DATE_DIFFERENCE':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        formatType: utilityData.formatType,
        datentime1: utilityData.datentime1,
        datentime2: utilityData.datentime2,
      };
      break;
    case 'DATE_ADD':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        datentime1: utilityData.datentime1,
        formatType: utilityData.formatType,
        unitToAdd: utilityData.unitToAdd,
        unitTypeToAdd: utilityData.unitTypeToAdd,
      };
      break;
    case 'BEAUTIFY_LIST':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        positionOfRecords: utilityData.positionOfRecords,
        numberOfRecords: utilityData.numberOfRecords,
        elementToRender: utilityData.elementToRender,
      };
      break;
    case 'URL_PARAMETERS':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        type: utilityData.type,
        field: utilityData.field,
      };
      break;
    case 'MARKDOWN_TO_HTML':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
      };
      break;
    case 'TABLE_FORMAT':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        tableRefernceFields: utilityData.tableRefernceFields,
        tableStyle: utilityData.tableStyle,
        theadStyle: utilityData.theadStyle,
        tbodyStyle: utilityData.tbodyStyle,
        trStyle: utilityData.trStyle,
        tdStyle: utilityData.tdStyle,
        thStyle: utilityData.thStyle,
      };
      break;
    case 'MASKING':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        visibleCharCount: utilityData.visibleCharCount,
        maskPosition: utilityData.maskPosition,
        maskCharacter: utilityData.maskCharacter,
      };
    default:
      return {};
  }
};

export const dynamicSort = (property) => {
  return (a, b) => {
    const result =
      !a[property] || !b[property]
        ? 0
        : a[property].toLowerCase() < b[property].toLowerCase()
        ? -1
        : a[property].toLowerCase() > b[property].toLowerCase()
        ? 1
        : 0;
    return result;
  };
};

export const snakeCaseToTitleCase = (str, checkForUnderscore = false) => {
  if (!str) return str;
  if (typeof str === 'string' && !checkForUnderscore) {
    return str
      .toLowerCase()
      .split('_')
      .map((word) => {
        return word.replace(word[0], word[0].toUpperCase());
      })
      .join(' ');
  }
  return str;
};

export const constantCaseToUpperCase = (str) => {
  if (!str) return str;
  if (typeof str === 'string') {
    return str
      .toLowerCase()
      .split('_')
      .map((word) => {
        return word.toUpperCase();
      })
      .join(' ');
  }
  return str;
};

export const camelCaseToTitleCase = (str) => {
  if (!str) return str;
  if (typeof str === 'string') {
    const result = str.replace(/([A-Z])/g, ' $1');
    const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
    return finalResult;
  }
  return str;
};

export const moveDefaultCollectionFieldsToEndAndSort = (fields, excludeRefField = false) => {
  const defaultFields = [];
  const customFields = [];
  fields.map((element) => {
    if ([uuid.id, ...systemDateField, createdBy.id].includes(element.fieldName)) {
      defaultFields.push(element);
    } else if (element.fieldName === isDeleted.id) {
    } else if (excludeRefField && ['reference'].includes(element.type)) {
    } else {
      customFields.push(element);
    }
  });
  return [
    ...customFields.sort(dynamicSort('fieldName')),
    ...defaultFields.sort(dynamicSort('fieldName')),
  ];
};

export const tabNameToTitle = (tab) => {
  switch (tab) {
    case 'appConstant':
      return 'App Constants';
    case 'appConfig':
      return 'App Settings';
    case 'pageSetting':
      return 'Page Settings';
    case 'robots':
      return 'Robots.txt';
    case 'pwaConfig':
      return 'PWA Configuration';
    case 'customCSS':
      return 'Custom CSS';
    case 'customJS':
      return 'Custom JavaScript';
    case 'pageSnapshot':
      return 'Page Snapshots';
    case 'collectionSnapshot':
      return 'Collection Snapshots';
    case 'snippetShapshot':
      return 'Snippet Snapshots';
    case 'dbExport':
      return 'Database Export';
    case 'devKey':
      return 'Developer API';
    case 'system-activity':
      return 'System Activity';
    case 'publish-activity':
      return 'Publish Activity';
    case 'js-update-page':
      return 'Page Custom JS';
    case 'sitemapXml':
      return 'Sitemap.xml';
    case 'typographyColours':
      return 'Typography & Colours';
    case 'aiModelConfig':
      return 'AI Model Configuration';
    case 'loaderScreen':
      return 'Loader Screen';
    case 'section':
      return 'Import From Figma';
    case 'phiAudit':
      return 'PHI Audit';
    default:
      return camelCaseToTitleCase(tab);
  }
};

export const tabs = [
  'pwaConfig',
  'customCSS',
  'customJS',
  'codeExport',
  'devKey',
  'dbExport',
  'customTheme',
  'encryption',
  'appConfig',
  'localization',
  'version',
  'pages',
  'profiler',
  'notificationSetting',
  'environment',
  'robots',
  'loadingIcon',
  'appConstant',
  'pageSetting',
  'pageSnapshot',
  'snippetShapshot',
  'system-activity',
  'publish-activity',
  'resources',
  'collectionSnapshot',
  'customFonts',
  'sitemapXml',
  'globalTheme',
  'typographyColours',
  'aiModelConfig',
];

export const menuKeys = [
  'appConstant',
  'appConfig',
  'pageSetting',
  'loadingIcon',
  'robots',
  'environment',
  'pwaConfig',
  'codeExport',
  'devKey',
  'dbExport',
  'encryption',
  'localization',
  'version',
  'pages',
  'profiler',
  'publish-activity',
  'resources',
  'system-activity',
  'Delete Permissions',
  'sitemapXml',
  'notificationSetting',
];

export const checkTabName = (pathName) => {
  if (pathName.endsWith('pwaConfig')) return 'pwaConfig';
  if (pathName.endsWith('customCSS')) return 'customCSS';
  if (pathName.endsWith('customJS')) return 'customJS';
  if (pathName.endsWith('customTheme')) return 'customTheme';
  if (pathName.endsWith('customFonts')) return 'customFonts';
  if (pathName.endsWith('codeExport')) return 'codeExport';
  if (pathName.endsWith('devKey')) return 'devKey';
  if (pathName.endsWith('dbExport')) return 'dbExport';
  if (pathName.endsWith('encryption')) return 'encryption';
  if (pathName.endsWith('localization')) return 'localization';
  if (pathName.endsWith('customComponent')) return 'customComponent';
  if (pathName.endsWith('version')) return 'version';
  if (pathName.endsWith('profiler')) return 'profiler';
  if (pathName.endsWith('pages')) return 'pages';
  if (pathName.endsWith('notificationSetting')) return 'notificationSetting';
  if (pathName.endsWith('environment')) return 'environment';
  if (pathName.endsWith('robots')) return 'robots';
  if (pathName.endsWith('loadingIcon')) return 'loadingIcon';
  if (pathName.endsWith('pageSetting')) return 'pageSetting';
  if (pathName.endsWith('appConstant')) return 'appConstant';
  if (pathName.endsWith('appConfig')) return 'appConfig';
  if (pathName.endsWith('pageSnapshot')) return 'pageSnapshot';
  if (pathName.endsWith('snippetShapshot')) return 'snippetShapshot';
  if (pathName.endsWith('system-activity')) return 'system-activity';
  if (pathName.endsWith('publish-activity')) return 'publish-activity';
  if (pathName.endsWith('resources')) return 'resources';
  if (pathName.endsWith('collectionSnapshot')) return 'collectionSnapshot';
  if (pathName.endsWith('sitemapXml')) return 'sitemapXml';
  if (pathName.endsWith('globalTheme')) return 'globalTheme';
  if (pathName.endsWith('typographyColours')) return 'typographyColours';
  if (pathName.endsWith('aiModelConfig')) return 'aiModelConfig';
};

export const expressionToString = (ex) => {
  return ex
    .replace(/##@@##@@##/g, ' ')
    .replace(/##@@##@@@@/g, '>')
    .replace(/@@@@##@@@@/g, '<')
    .replace(/U\+0022/g, '"')
    .replace(/U\+0027/g, "'")
    .replace(/U\+000A/g, '\n');
};

const stringToExpression = (str) => {
  return str
    .replace(/ /g, '##@@##@@##')
    .replace(/>/g, '##@@##@@@@')
    .replace(/</g, '@@@@##@@@@')
    .replace(/\n/g, 'U+000A')
    .replace(/"/g, 'U+0022')
    .replace(/'/g, 'U+0027');
};

export const awsRegion = [
  { label: 'US East (Ohio)', value: 'us-east-2' },
  { label: 'US East (N. Virginia)', value: 'us-east-1' },
  { label: 'US West (N. California)', value: 'us-west-1' },
  { label: 'US West (Oregon)', value: 'us-west-2' },
  { label: 'Africa (Cape Town)', value: 'af-south-1' },
  { label: 'Asia Pacific (Hong Kong)', value: 'ap-east-1' },
  { label: 'Asia Pacific (Mumbai)', value: 'ap-south-1' },
  { label: 'Asia Pacific (Osaka-Local)', value: 'ap-northeast-3' },
  { label: 'Asia Pacific (Seoul)', value: 'ap-northeast-2' },
  { label: 'Asia Pacific (Singapore)', value: 'ap-southeast-1' },
  { label: 'Asia Pacific (Sydney)', value: 'ap-southeast-2' },
  { label: 'Asia Pacific (Tokyo)', value: 'ap-northeast-1' },
  { label: 'Canada (Central)', value: 'ca-central-1' },
  { label: 'China (Beijing)', value: 'cn-north-1' },
  { label: 'China (Ningxia)', value: 'cn-northwest-1' },
  { label: 'Europe (Frankfurt)', value: 'eu-central-1' },
  { label: 'Europe (Ireland)', value: 'eu-west-1' },
  { label: 'Europe (London)', value: 'eu-west-2' },
  { label: 'Europe (Milan)', value: 'eu-south-1' },
  { label: 'Europe (Paris)', value: 'eu-west-3' },
  { label: 'Europe (Stockholm)', value: 'eu-north-1' },
  { label: 'Middle East (Bahrain)', value: 'me-south-1' },
  { label: 'South America (São Paulo)', value: 'sa-east-1' },
];

export const labelForFunctionMethod = (key) => {
  let label = '';
  switch (key) {
    case 'COUNT':
      label = 'Data - Count of Records';
      break;
    case 'FIND_RECORD':
      label = 'Data - Find Specific Record';
      break;
    case 'PERCENTAGE':
      label = 'Data - Percentage (%) of Records';
      break;
    case 'FORMAT_DATE':
      label = snakeCaseToTitleCase('DATE_FORMAT');
      break;
    case 'URL_PARAMETERS':
      label = 'URL Parameters';
      break;
    case 'MARKDOWN_TO_HTML':
      label = 'Markdown to HTML';
      break;
    default:
      label = snakeCaseToTitleCase(key);
      break;
  }
  return label;
};

export const updateUserIpInCookie = async () => {
  try {
    const expires = new Date(Date.now() + 86400000);
    const apiData = await axios.get(`https://api.ipify.org/?format=json`);
    const publicIp = apiData.data.ip;
    cookie.save('userIp', publicIp, { expires });
    return publicIp;
  } catch (error) {
    console.error('An error occurred:', error);
    return null;
  }
};

export const formatJsonBody = (jsonData) => {
  const { body, collectionParamsValue } = jsonData;

  const dataObject = {};
  body.data.forEach((item) => {
    dataObject[item.key] = item.value;
  });

  const transformedData = {
    documentId: '',
    permissions: ['read("any")'],
    data: {
      ...dataObject,
      ...collectionParamsValue,
    },
  };

  return transformedData;
};

export const formatJsonForPatch = (inputData) => {
  inputData.url = inputData.url.replace(
    '{{_data_source_rest_api_primary_id}}',
    inputData.collectionParamsValue['_data_source_rest_api_primary_id'],
  );

  const convertArrayToObject = (inputArray) => {
    const resultObject = {};

    inputArray.forEach((item) => {
      if (item.key !== '_data_source_rest_api_primary_id') {
        resultObject[item.key] = item.value;
      }
    });

    return resultObject;
  };

  inputData.body = { data: convertArrayToObject(inputData.body.data) };

  delete inputData.body.type;
  delete inputData.body.requestType;

  return inputData;
};

export const formatCollectionAndFieldName = (str) => {
  let updateString = cleanCollectionAndFieldName(str);
  return clearSpaceAndReformat(updateString.trim(), '_');
};
export const cleanCollectionAndFieldName = (str) => {
  str = str.replace(/[^a-zA-Z0-9 ]/, '');
  return str;
};
export const clearSpaceAndReformat = (text, separator) => {
  if (!text) {
    return '';
  }
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, separator ? separator : '');
};

export const objectCleanup = (type = '', obj) => {
  if (Object.keys(obj).length) {
    switch (type) {
      case REST_API:
        delete obj._id;
        delete obj.__v;
        delete obj.uuid;
        delete obj.createdAt;
        delete obj.updatedAt;
        delete obj.projectVersion;
        break;
      default:
        delete obj._id;
        delete obj.__v;
        break;
    }
  }
};

export const themeNames = [
  'cerulean',
  'cosmo',
  'cyborg',
  'darkly',
  'flatly',
  'journal',
  'litera',
  'lumen',
  'lux',
  'materia',
  'minty',
  'morph',
  'pulse',
  'quartz',
  'sandstone',
  'simplex',
  'sketchy',
  'slate',
  'solar',
  'spacelab',
  'superhero',
  'united',
  'vapor',
  'yeti',
  'zephyr',
];
export const convertConstantCaseToTitleCase = (str, commaSeparatedException = '') => {
  if (!str) return str;
  const overrideMap = {
    CLAUDE_AI: 'Anthropic AI',
  };
  if (overrideMap[str]) {
    return overrideMap[str];
  }
  const exceptions = commaSeparatedException ? commaSeparatedException.split(',') : [];
  if (typeof str === 'string') {
    return str
      .split('_')
      .map((word) => {
        return exceptions && exceptions.includes(word)
          ? word
          : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  }
  return str;
};

export const menuItemsForAppConstant = [
  { key: 'app-config', label: 'App Settings', icon: 'appConfig' },
  { key: 'appConstant', label: 'App Constants', icon: 'appConstant' },
  { key: 'pwa-config', label: 'PWA Configuration', icon: 'pwa', requiresProjectDetail: true },
  { key: 'pageSetting', label: 'Page Settings', icon: 'pageSettings' },
  { key: 'robots', label: 'Robots.txt', icon: 'robotTxt', requiresProjectDetail: true },
  { key: 'sitemapXml', label: 'Sitemap.xml', icon: 'sitemapXml', requiresProjectDetail: true },
  { key: 'environment', label: 'Environment', icon: 'environment' },
  { key: 'devKey', label: 'Developer API', icon: 'devKey', requiresProjectDetail: true },
  {
    key: 'encryption-section',
    label: 'Data Encryption',
    icon: 'encryption',
    requiresProjectDetail: true,
  },
  { key: 'version', label: 'Project Version', icon: 'version' },

  {
    key: 'localization-section',
    label: 'Localization',
    icon: 'localization',
    requiresProjectDetail: true,
  },
  {
    key: 'resources',
    label: 'Resources',
    icon: 'webconnect-cloud-arrow-up',
    requiresProjectDetail: true,
    directIcon: true,
  },
  { key: 'phi-audit', label: 'PHI Audit', icon: 'phiAudit' },
];

export const menuItemsForSnapshot = [
  { key: 'pageSnapshot', label: 'Page Snapshots', icon: 'pageSnapshots' },
  { key: 'snippetShapshot', label: 'Snippet Snapshots', icon: 'snippetSnapshots' },
  { key: 'collectionSnapshot', label: 'Collection Snapshots', icon: 'collection' },
];
export const menuItemsForActivity = [
  { key: 'system-activity', label: 'System Activity', icon: 'webconnect-cpu', directIcon: true },
  {
    key: 'publish-activity',
    label: 'Publish Activity',
    icon: 'webconnect-paper-plane',
    directIcon: true,
  },
  { key: 'profiler-section', label: 'Profiler', icon: 'profiler' },
];
export const menuItemsForCustomCssJs = [
  { key: 'custom-css', label: 'Custom CSS', icon: 'customCSS' },
  { key: 'custom-js', label: 'Custom JavaScript', icon: 'customJS' },
  { key: 'customFonts', label: 'Custom Fonts', icon: 'customFonts' },
  { key: 'globalTheme', label: 'Global Theme', icon: 'drapcode-icons' },
  { key: 'typographyColours', label: 'Typography & Colours', icon: 'typographyColours' },
  {
    key: 'notificationSetting',
    label: 'Notification Settings',
    icon: 'notification',
  },
  { key: 'loadingIcon', label: 'Loading Icon', icon: 'loadingIcon' },
  { key: 'loader-screen', label: 'Loader Screen', icon: 'loaderScreen' },
  { key: 'figmaConfig-section', label: 'Import From Figma', icon: 'section' },
];
export const menuItemsForCustomComp = [
  { key: 'customComponent', label: 'Custom Component', icon: 'customComponent' },
  { key: 'customDataMapping', label: 'Custom Data Mapping', icon: 'customDataMapping' },
  { key: 'customFunction', label: 'Custom Function', icon: 'customFunction' },
];
export const menuItemsForAIModel = [
  {
    key: 'aiModelConfig-section',
    icon: 'aiModelConfig',
    label: 'AI Model Configuration',
  },
];

export const getAppSettingBasePath = (key, version, projectId) =>
  `/app-setting/${version}/v/${projectId}/setting/${key}`;

export const isAppSettingActive = (pathname, key, version, projectId) =>
  pathname.startsWith(getAppSettingBasePath(key, version, projectId));

export const isDeletePermissionActive = (pathname, version, projectId) =>
  pathname.startsWith(`/permission/${version}/v/${projectId}`);

export const getCurrentUserAndTenantFieldsForCurrency = (collections, plugins, finalOptions) => {
  finalOptions = [{ label: 'Currency', options: [...finalOptions] }];
  const userCollection =
    collections &&
    collections.find((collection) => {
      return collection.collectionName === 'user';
    });
  const isUserCollectionExist = !!(userCollection && Object.keys(userCollection).length);
  let currentUserFields = [];
  // User Fields
  if (isUserCollectionExist) {
    currentUserFields = userCollection.fields
      .filter((field) => field.type === 'text')
      .map((field) => ({
        value: {
          name: field.fieldTitle.en,
          code: `current_user.${field.fieldName}`,
          symbol: `current_user.${field.fieldName}`,
        },
        label: field.fieldTitle.en,
      }));
  }
  const multiTenantPlugin = plugins && plugins.find((e) => e.code === 'MULTI_TENANT_SAAS');
  let multiTenantCollectionUuid = '';
  if (
    multiTenantPlugin &&
    multiTenantPlugin.setting &&
    multiTenantPlugin.setting.multiTenantCollection
  )
    multiTenantCollectionUuid = multiTenantPlugin.setting.multiTenantCollection;
  let currentTenantFields = [];
  // Tenant Fields
  if (multiTenantCollectionUuid) {
    const multiTenantCollection =
      collections &&
      collections.find(
        (collection) =>
          collection.uuid === multiTenantCollectionUuid && collection.isTenantCollection,
      );
    currentTenantFields = multiTenantCollection.fields
      ? multiTenantCollection.fields
          .filter((field) => field.type === 'text')
          .map((field) => ({
            value: {
              name: field.fieldTitle.en,
              code: `current_tenant.${field.fieldName}`,
              symbol: `current_tenant.${field.fieldName}`,
            },
            label: field.fieldTitle.en,
          }))
      : [];
  }

  if (currentUserFields.length)
    finalOptions.push({ label: 'Current LoggedIn User Field', options: [...currentUserFields] });
  if (currentTenantFields.length)
    finalOptions.push({
      label: 'Current LoggedIn Tenant Field',
      options: [...currentTenantFields],
    });

  return finalOptions;
};

export const phoneNumberCountryCode = [
  { name: 'Afghanistan', iso2: 'af' },
  { name: 'Albania', iso2: 'al' },
  { name: 'Algeria', iso2: 'dz' },
  { name: 'American Samoa', iso2: 'as' },
  { name: 'Andorra', iso2: 'ad' },
  { name: 'Angola', iso2: 'ao' },
  { name: 'Anguilla', iso2: 'ai' },
  { name: 'Antarctica', iso2: 'aq' },
  { name: 'Antigua and Barbuda', iso2: 'ag' },
  { name: 'Argentina', iso2: 'ar' },
  { name: 'Armenia', iso2: 'am' },
  { name: 'Aruba', iso2: 'aw' },
  { name: 'Australia', iso2: 'au' },
  { name: 'Austria', iso2: 'at' },
  { name: 'Azerbaijan', iso2: 'az' },
  { name: 'Bahamas', iso2: 'bs' },
  { name: 'Bahrain', iso2: 'bh' },
  { name: 'Bangladesh', iso2: 'bd' },
  { name: 'Barbados', iso2: 'bb' },
  { name: 'Belarus', iso2: 'by' },
  { name: 'Belgium', iso2: 'be' },
  { name: 'Belize', iso2: 'bz' },
  { name: 'Benin', iso2: 'bj' },
  { name: 'Bermuda', iso2: 'bm' },
  { name: 'Bhutan', iso2: 'bt' },
  { name: 'Bolivia', iso2: 'bo' },
  { name: 'Bosnia and Herzegovina', iso2: 'ba' },
  { name: 'Botswana', iso2: 'bw' },
  { name: 'Brazil', iso2: 'br' },
  { name: 'British Indian Ocean Territory', iso2: 'io' },
  { name: 'Brunei Darussalam', iso2: 'bn' },
  { name: 'Bulgaria', iso2: 'bg' },
  { name: 'Burkina Faso', iso2: 'bf' },
  { name: 'Burundi', iso2: 'bi' },
  { name: 'Cambodia', iso2: 'kh' },
  { name: 'Cameroon', iso2: 'cm' },
  { name: 'Canada', iso2: 'ca' },
  { name: 'Cape Verde', iso2: 'cv' },
  { name: 'Cayman Islands', iso2: 'ky' },
  { name: 'Central African Republic', iso2: 'cf' },
  { name: 'Chad', iso2: 'td' },
  { name: 'Chile', iso2: 'cl' },
  { name: 'China', iso2: 'cn' },
  { name: 'Colombia', iso2: 'co' },
  { name: 'Comoros', iso2: 'km' },
  { name: 'Congo', iso2: 'cg' },
  { name: 'Congo (Democratic Republic)', iso2: 'cd' },
  { name: 'Costa Rica', iso2: 'cr' },
  { name: 'Croatia', iso2: 'hr' },
  { name: 'Cuba', iso2: 'cu' },
  { name: 'Cyprus', iso2: 'cy' },
  { name: 'Czech Republic', iso2: 'cz' },
  { name: 'Denmark', iso2: 'dk' },
  { name: 'Djibouti', iso2: 'dj' },
  { name: 'Dominica', iso2: 'dm' },
  { name: 'Dominican Republic', iso2: 'do' },
  { name: 'Ecuador', iso2: 'ec' },
  { name: 'Egypt', iso2: 'eg' },
  { name: 'El Salvador', iso2: 'sv' },
  { name: 'Estonia', iso2: 'ee' },
  { name: 'Ethiopia', iso2: 'et' },
  { name: 'Fiji', iso2: 'fj' },
  { name: 'Finland', iso2: 'fi' },
  { name: 'France', iso2: 'fr' },
  { name: 'Germany', iso2: 'de' },
  { name: 'Ghana', iso2: 'gh' },
  { name: 'Greece', iso2: 'gr' },
  { name: 'Greenland', iso2: 'gl' },
  { name: 'Grenada', iso2: 'gd' },
  { name: 'Guatemala', iso2: 'gt' },
  { name: 'Guinea', iso2: 'gn' },
  { name: 'Guinea-Bissau', iso2: 'gw' },
  { name: 'Guyana', iso2: 'gy' },
  { name: 'Haiti', iso2: 'ht' },
  { name: 'Honduras', iso2: 'hn' },
  { name: 'Hong Kong', iso2: 'hk' },
  { name: 'Hungary', iso2: 'hu' },
  { name: 'Iceland', iso2: 'is' },
  { name: 'India', iso2: 'in' },
  { name: 'Indonesia', iso2: 'id' },
  { name: 'Iran', iso2: 'ir' },
  { name: 'Iraq', iso2: 'iq' },
  { name: 'Ireland', iso2: 'ie' },
  { name: 'Israel', iso2: 'il' },
  { name: 'Italy', iso2: 'it' },
  { name: 'Jamaica', iso2: 'jm' },
  { name: 'Japan', iso2: 'jp' },
  { name: 'Jordan', iso2: 'jo' },
  { name: 'Kazakhstan', iso2: 'kz' },
  { name: 'Kenya', iso2: 'ke' },
  { name: 'Kuwait', iso2: 'kw' },
  { name: 'Kyrgyzstan', iso2: 'kg' },
  { name: 'Laos', iso2: 'la' },
  { name: 'Latvia', iso2: 'lv' },
  { name: 'Lebanon', iso2: 'lb' },
  { name: 'Lesotho', iso2: 'ls' },
  { name: 'Liberia', iso2: 'lr' },
  { name: 'Libya', iso2: 'ly' },
  { name: 'Lithuania', iso2: 'lt' },
  { name: 'Luxembourg', iso2: 'lu' },
  { name: 'Macau', iso2: 'mo' },
  { name: 'Macedonia', iso2: 'mk' },
  { name: 'Madagascar', iso2: 'mg' },
  { name: 'Malawi', iso2: 'mw' },
  { name: 'Malaysia', iso2: 'my' },
  { name: 'Maldives', iso2: 'mv' },
  { name: 'Mali', iso2: 'ml' },
  { name: 'Malta', iso2: 'mt' },
  { name: 'Mauritius', iso2: 'mu' },
  { name: 'Mexico', iso2: 'mx' },
  { name: 'Moldova', iso2: 'md' },
  { name: 'Monaco', iso2: 'mc' },
  { name: 'Mongolia', iso2: 'mn' },
  { name: 'Montenegro', iso2: 'me' },
  { name: 'Morocco', iso2: 'ma' },
  { name: 'Mozambique', iso2: 'mz' },
  { name: 'Myanmar', iso2: 'mm' },
  { name: 'Namibia', iso2: 'na' },
  { name: 'Nepal', iso2: 'np' },
  { name: 'Netherlands', iso2: 'nl' },
  { name: 'New Zealand', iso2: 'nz' },
  { name: 'Nicaragua', iso2: 'ni' },
  { name: 'Niger', iso2: 'ne' },
  { name: 'Nigeria', iso2: 'ng' },
  { name: 'Norway', iso2: 'no' },
  { name: 'Oman', iso2: 'om' },
  { name: 'Pakistan', iso2: 'pk' },
  { name: 'Palestine', iso2: 'ps' },
  { name: 'Panama', iso2: 'pa' },
  { name: 'Papua New Guinea', iso2: 'pg' },
  { name: 'Paraguay', iso2: 'py' },
  { name: 'Peru', iso2: 'pe' },
  { name: 'Philippines', iso2: 'ph' },
  { name: 'Poland', iso2: 'pl' },
  { name: 'Portugal', iso2: 'pt' },
  { name: 'Puerto Rico', iso2: 'pr' },
  { name: 'Qatar', iso2: 'qa' },
  { name: 'Romania', iso2: 'ro' },
  { name: 'Russia', iso2: 'ru' },
  { name: 'Rwanda', iso2: 'rw' },
  { name: 'Saint Kitts and Nevis', iso2: 'kn' },
  { name: 'Saint Lucia', iso2: 'lc' },
  { name: 'Saint Vincent and the Grenadines', iso2: 'vc' },
  { name: 'Samoa', iso2: 'ws' },
  { name: 'San Marino', iso2: 'sm' },
  { name: 'Saudi Arabia', iso2: 'sa' },
  { name: 'Senegal', iso2: 'sn' },
  { name: 'Serbia', iso2: 'rs' },
  { name: 'Seychelles', iso2: 'sc' },
  { name: 'Sierra Leone', iso2: 'sl' },
  { name: 'Singapore', iso2: 'sg' },
  { name: 'Slovakia', iso2: 'sk' },
  { name: 'Slovenia', iso2: 'si' },
  { name: 'Solomon Islands', iso2: 'sb' },
  { name: 'Somalia', iso2: 'so' },
  { name: 'South Africa', iso2: 'za' },
  { name: 'South Korea', iso2: 'kr' },
  { name: 'Spain', iso2: 'es' },
  { name: 'Sri Lanka', iso2: 'lk' },
  { name: 'Sudan', iso2: 'sd' },
  { name: 'Suriname', iso2: 'sr' },
  { name: 'Swaziland', iso2: 'sz' },
  { name: 'Sweden', iso2: 'se' },
  { name: 'Switzerland', iso2: 'ch' },
  { name: 'Syria', iso2: 'sy' },
  { name: 'Taiwan', iso2: 'tw' },
  { name: 'Tajikistan', iso2: 'tj' },
  { name: 'Tanzania', iso2: 'tz' },
  { name: 'Thailand', iso2: 'th' },
  { name: 'Togo', iso2: 'tg' },
  { name: 'Tonga', iso2: 'to' },
  { name: 'Trinidad and Tobago', iso2: 'tt' },
  { name: 'Tunisia', iso2: 'tn' },
  { name: 'Turkey', iso2: 'tr' },
  { name: 'Turkmenistan', iso2: 'tm' },
  { name: 'Uganda', iso2: 'ug' },
  { name: 'Ukraine', iso2: 'ua' },
  { name: 'United Arab Emirates', iso2: 'ae' },
  { name: 'United Kingdom', iso2: 'gb' },
  { name: 'United States', iso2: 'us' },
  { name: 'Uruguay', iso2: 'uy' },
  { name: 'Uzbekistan', iso2: 'uz' },
  { name: 'Vanuatu', iso2: 'vu' },
  { name: 'Vatican City', iso2: 'va' },
  { name: 'Venezuela', iso2: 've' },
  { name: 'Vietnam', iso2: 'vn' },
  { name: 'Yemen', iso2: 'ye' },
  { name: 'Zambia', iso2: 'zm' },
  { name: 'Zimbabwe', iso2: 'zw' },
];

export const getCookie = (key) => {
  return cookie.load(key);
};

export const isProjectReadOnly = (projectId) => {
  const readOnlyProjectIds = getCookie('readOnlyProjectIds') || [];
  return Array.isArray(readOnlyProjectIds) && readOnlyProjectIds.includes(projectId);
};
